import { useCompareContext } from '../../../context/PlpContext';
import { useEffect, useState } from 'react';

export const useAnalyticsCompareUpdate = () => {
  const { isOpen: isCompareOpen } = useCompareContext();

  const [compareIsOpen, setCompareIsOpen] = useState(isCompareOpen);

  useEffect(() => {
    setCompareIsOpen(isCompareOpen);
  }, [isCompareOpen]);

  return {
    compareIsOpen,
  };
};
